<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>


export default {
  name: 'app',
  components: {

  }
}
</script>

<style>
  html, body {
    margin: 0;
    padding:0;
    min-height: 100%;
  }
</style>
